"use client";

import { Loader } from "@mantine/core";
import { useAppContext } from "@repo/dashboard-core";
import type { ReactNode } from "react";

import { ServiceDummy } from "./ServiceDummy";

/**
 * Paywall for the subscriber-only services. Renders `children` — an embedded
 * hosted service, or a natively built one like eSIM — once the customer has a
 * running subscription.
 */
export function ServiceGuard({
  children,
  preview,
}: {
  children: ReactNode;
  /** Passed through to the paywall's screenshot — see `ServiceDummy`. */
  preview?: string;
}) {
  const { subscriptionsInfo } = useAppContext();

  // Still loading subscription data
  if (!subscriptionsInfo) {
    return (
      <div className="flex h-80 items-center justify-center">
        <Loader size={48} variant="oval" color="var(--shell-primary)" />
      </div>
    );
  }

  const hasActiveSubscription = subscriptionsInfo.runningSubscriptions.some(
    (sub) => sub.status === "active",
  );

  return hasActiveSubscription ? (
    <>{children}</>
  ) : (
    <ServiceDummy preview={preview} />
  );
}
